
import { defineComponent, computed, ref, defineExpose } from "vue";
import type { ITeachersModel } from "@/interfaces/modules/aula/ITeachersModel";

export default defineComponent({
  name: "TabAcademicTeacher",
  props: {
    record: { type: Object as () => ITeachersModel, required: true },
    wasValidated: { type: Boolean, default: false },
  },
  emits: ["update:record"],
  setup(props, { emit }) {
    const recordProxy = computed<ITeachersModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    // --- NEW: Local ref to hold the File
    const cvFile = ref<File | null>(null);

    // If your ImageUpload emits the selected File as its payload:
    // <ImageUpload @filechanged="handleFileChange" />
    const handleFileChange = (payload: File | File[] | FileList | null) => {
      let file: File | null = null;

      if (payload instanceof File) file = payload;
      else if (Array.isArray(payload) && payload[0] instanceof File) file = payload[0];
      else if (payload && "length" in payload && payload.length > 0 && payload[0] instanceof File)
        file = payload[0];

      cvFile.value = file;

      // Keep a human-readable path/name in your record if you like:
      if (file) {
        const name = file.name;
        recordProxy.value = { ...recordProxy.value, CVPath: name };
      } else {
        recordProxy.value = { ...recordProxy.value, CVPath: "" };
      }
    };

    // expose a getter so the parent can read the File when building FormData
    const getCvFile = () => cvFile.value;
    defineExpose({ getCvFile });



    const toNumber = (v: any) => (v === "" || v === null || v === undefined ? null : Number(v));
    const updateField = (key: keyof ITeachersModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };

    const validate = () => ({ ok: true });

    return {
      recordProxy,
      updateField,
      toNumber,
      // NEW
      handleFileChange,
      getCvFile,
      validate,
    };
  },
});
